var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap d-flex flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-12 text-center"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }